import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

/**
 * ConfirmDialog
 * Diálogo de Confirmação Premium (NeoConfirm) integrado ao padrão Taça Outono do NeoApp.
 */
const ConfirmDialog = async ({
    title = 'Tem certeza?',
    text = 'Essa ação não poderá ser revertida!',
    icon = 'warning', // 'warning', 'success', 'error', 'info', 'question'
    confirmButtonText = 'Sim, continuar',
    cancelButtonText = 'Cancelar'
}) => {
    const result = await Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText,
        allowOutsideClick: false, // UX Ideal: impede fechar ao clicar fora
        allowEscapeKey: false,    // UX Ideal: impede fechar com Esc
        customClass: {
            container: 'confirm-dialog-container',
            popup: 'confirm-dialog-popup',
            confirmButton: 'confirm-dialog-confirm-btn swal2-confirm',
            cancelButton: 'confirm-dialog-cancel-btn swal2-cancel'
        },
        buttonsStyling: false
    });



    return result.isConfirmed;
};

export default ConfirmDialog;

